import * as React from 'react';
import Layout from 'shared/layouts/NoIdentity'

interface NotFoundProps {
    footerContent?: React.FunctionComponent | React.ReactElement | string
}

const NotFound: React.FunctionComponent<NotFoundProps> = (props: NotFoundProps) => {

    return (
        <Layout footerContent={props.footerContent}>
            <div className='color-overlay d-flex justify-content-center align-items-center mt-5'>
                <h1>
                    404 Not Found
                </h1>
            </div>
        </Layout>
    );
}

export default NotFound;